/**
 * Created by ivo on 21.08.14.
 *
 * Component to make vailibility check for offers and show result
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-util/url',
    'library/fcse-util/paramConverter',
    'library/fcse-events/eventDispatcher'
    ],
    function($, _, Object, OptionsMixin, Url, ParamConverter, EventDispatcher) {
        /**
         * Creates an availibility check button
         *
         * @param element jQuery selector or DOM element
         * @param {MultiRequestHandler} requestHandler
         * @param {object} options
         * @constructor
         */
        var OfferValidityCheckButton = function (element, requestHandler, options) {
            // Call Constructor of parent class
            EventDispatcher.apply(this, arguments);

            // Set elements
            this.element = $(element);
            this.requestHandler = requestHandler;

            var defaultOptions = {
                routeName: 'allt_frontend.offer_check',
                'offer-selector': '[data-fcse-role="offer-item"]',
                'request-type': 'fcse-request-id',
                'product-search-id': 'fcse-product-search-id',
                'icon': '<span class="icon-arrow-right offerhorizontal--pricebtn--icon"></span>',
                'withTooltipClass': 'with-tooltip',
                offerValidityBarSelector: '[data-fcse-role="offervaliditybar"]:first',
                offerValidityBarTextSelector: '[data-fcse-role="offervalidity-statetext"]',
                newPricePersonSelector: '[data-fcse-role="price-pp"] [data-fcse-role="price--amount"]',
                newPriceTotalSelector: '[data-fcse-role="price-total"] [data-fcse-role="price--amount"]',
                newPricePersonLocaledSelector: '[data-fcse-role="price-pp"] [data-fcse-role="price--amount-converted"]',
                newPriceTotalLocaledSelector: '[data-fcse-role="price-total"] [data-fcse-role="price--amount-converted"]',
                oldPricePersonSelector: '[data-fcse-role="price--old-value"]',
                oldPriceSavedSelector: '[data-fcse-role="price--old-saved"]',
                alternativeOffersSelector: '[data-fcse-role="alternatives-container"]',
                offerValidityCheckDataName: 'offer-valitity-check',
                offerValidityBarState: {
                    checking: 'is-checking',
                    unavailable: 'is-unavailable',
                    cheaper: 'is-cheaper',
                    expensive: 'is-expensive',
                    available: 'is-available'
                },
                offerState: {
                    checking: 'is-checking',
                    unavailable: 'is-unavailable',
                    cheaper: 'is-cheaper',
                    expensive: 'is-expensive',
                    available: 'is-available'
                }
            };

            // Add default options and custom options
            this.addOptions(defaultOptions, options);

            this._init();
        };

        OfferValidityCheckButton.prototype = $.extend(Object.create(EventDispatcher.prototype), OptionsMixin, {
            /**
             * The requestData object, to check if the multiRequestHandler response is for this instance
             */
            _requestData: null,

            /**
             * The check request result data object
             */
            _checkRequestResult: null,

            /**
             * Indiciates if offer is available
             * If an error occured it is set to true and you can't redirect to checkout
             */
            _isNotAvailable: false,

            /**
             * Initializer
             * @private
             */
            _init: function() {
                var checkData = this.element.data(this.option('offerValidityCheckDataName'));
                // Applies offer availability status if any
                if (checkData) {
                    var data = JSON.parse(JSON.parse(checkData));
                    this._setOfferCheckStatus(data);
                }
                // Regsiter All Locations Click Event
                this._initListeners();
            },

            /**
             * Initializes all event listeners
             * @private
             */
            _initListeners: function() {
                $(this.element).click($.proxy(this._onClick, this));

                this.requestHandler.on('success', $.proxy(this._handleOfferCheckResponse, this));
            },

            /**
             * Offer button click handler
             *
             * @private
             */
            _onClick: function(e) {
                var element = this.element.closest(this.option('offer-selector')),
                    type = this.option('request-type'),
                    requestId = element.closest('[data-'+type+']'),
                    productSearchType = this.option('product-search-id'),
                    productSearch = element.closest('[data-'+productSearchType+']');
                // Check if request is pending
                if (this._requestData !== null){
                    return;
                }


                // Check if offer is not available (error)
                if (this._isNotAvailable){
                    return;
                }

                // If check request was made, redirect to checkout
                if (this._checkRequestResult !== null){
                    this._redirectToCheckout();
                    return;
                }

                this.element.data({
                    preventLinkFunction: this._preventLink,
                    postRedirectFunction: this._redirectPost
                });

                // Set classes for loading
                this.element.addClass('loading').text(this.element.data('fcse-loading-text'));
                this._setOfferValidityBarState('checking');

                // this.element.off('click', that._onCheckOfferClick);
                // this.element.on('click', that._preventLink);
                var params = {
                    productSearchId: productSearch.attr('data-fcse-product-search-id'),
                    offerIndex: element.attr('data-fcse-offer-index'),
                    requestId: requestId.attr('data-'+type),
                    returnUrl: window.location.href,
                    bookingKey: this.element.closest('[data-fcse-booking-key]').attr('data-fcse-booking-key'),
                    bookingObj: this.element.closest('[data-fcse-booking-data]').attr('data-fcse-booking-data')
                };

                this._requestData = this.requestHandler.send(this.option('routeName'), params, {}, {method: 'POST'});
            },

            /**
             * Handle successful response from offer check
             *
             * @param requestData
             * @private
             */
            _handleOfferCheckResponse: function(data, requestData) {
                if (!this._requestData || requestData.route !== this.option('routeName') || requestData.xhr !== this._requestData.xhr){
                    return;
                }
                this._setOfferCheckStatus(data);
            },

            _setOfferCheckStatus: function(data) {
                var offerElement = this.element.closest(this.option('offer-selector'));

                // Parse check result
                var resp = JSON.parse(data.meta.checkResult),
                    self = this,
                    icon = this.option('icon'),
                    withTooltipClass = this.option('withTooltipClass'),
                    showModal = function(className, text) {
                        var modal = $('<div />'),
                            timeout;
                        self.element.addClass(className).html(text);
                        if (!_.isString(resp.infoLines) || resp.infoLines.length === 0) {
                            return;
                        }
                        self.element.addClass(withTooltipClass);

                        modal.addClass('tooltip tooltip-availibility').html(resp.infoLines);

                        if (resp.cheaper){
                            modal.addClass('is-cheaper');
                        } else {
                            modal.addClass('is-expensive');
                        }

                        modal.insertAfter(self.element);
                        self.element.on('mouseenter', function() {
                            timeout = setTimeout(function() {
                                modal.show();
                            }, 100);
                        }).
                            on('mouseleave', function() {
                                clearTimeout(timeout);
                                modal.hide();
                            });
                    };

                // Reset request data
                this._requestData = null;

                // Set response
                this._checkRequestResult = {
                    checkResult: resp,
                    partnerId: data.meta.partnerId,
                    mlid: data.meta.mlid,
                    coyoteId: data.meta.coyoteId,
                    exchangerate: offerElement.data('fcse-conversion-rate')
                };

                // Remove loading state
                this.element.removeClass('loading');

                const isFlightsChanged = function (resp) {
                    if (_.isUndefined(resp.flightsChanges)) {
                        return false;
                    }

                    if (_.isUndefined(resp.flightsChanges.departureFlightChanged) &&
                        _.isUndefined(resp.flightsChanges.returnFlightChanged)) {
                        return false;
                    }

                    return true;
                };

                if (resp.success === false) {
                    showModal('error', resp.text);
                    this._isNotAvailable = true;
                    this._setOfferValidityBarState('unavailable');
                } else {
                    // Create modal window with additional info
                    const flightsChanged = isFlightsChanged(resp);
                    if ((!_.isUndefined(resp.infoLines) && resp.infoLines.length !== 0) || flightsChanged) {
                        var modal = $('<div />'),
                            timeout;
//                        this.element.addClass('warning');
                        this.element.addClass('success');
                        //this.element.text(resp.text + ' '+String.fromCharCode(9654));
                        this.element.text(resp.text);

                        /*
                         // @TODO: Remove once it is clarified if we need modal or not
                         modal.addClass('tooltip').html(resp.infoLines);
                         modal.insertAfter(this.element);
                         this.element.on('mouseenter', function() {
                         timeout = setTimeout(function() {
                         modal.show();
                         }, 100);
                         }).
                         on('mouseleave', function() {
                         clearTimeout(timeout);
                         modal.hide();
                         });
                         */

                        // Check if is cheaper or more expensive
                        var oldPriceTotal = parseFloat(offerElement.attr('data-price-total'));
                        var oldPricePerson = parseFloat(offerElement.attr('data-price-person'));
                        var newPriceTotal = oldPriceTotal;
                        var newPricePerson = oldPricePerson;

                        // Get prices from response
                        if (!_.isUndefined(resp.totalPrice)){
                            newPriceTotal = Math.ceil(parseFloat(resp.totalPrice));
                        }
                        if (!_.isUndefined(resp.personPrice)){
                            newPricePerson = Math.ceil(parseFloat(resp.personPrice));
                        }
                        var oldPriceConvertedTotal = Math.ceil(offerElement.data('fcse-conversion-rate') * newPricePerson),
                            oldPriceConvertedPerson = Math.ceil(offerElement.data('fcse-conversion-rate') * newPriceTotal);

                        var filterExcludeAlternatives= function () {
                            return !$(this).closest(self.option('alternativeOffersSelector')).length;
                        };

                        // Set prices in bar
                        if (offerElement.closest(this.option('alternativeOffersSelector')).length) {
                          offerElement.find(this.option('newPricePersonSelector')).text(newPricePerson);
                        } else {
                          offerElement.find(this.option('newPricePersonSelector')).filter(filterExcludeAlternatives).text(newPricePerson);
                        }
                        offerElement.find(this.option('newPriceTotalSelector')).text(newPriceTotal);
                        offerElement.find(this.option('newPricePersonLocaledSelector')).text(oldPriceConvertedTotal);
                        offerElement.find(this.option('newPriceTotalLocaledSelector')).text(oldPriceConvertedPerson);

                        if (offerElement.find(this.option('oldPricePersonSelector')).length) {
                            var oldPricePP = Math.ceil(offerElement.find(this.option('oldPricePersonSelector')).data('price-old'));
                            savedPrice = oldPricePP - newPricePerson;
                            if (savedPrice > 0) {
                                var valCurrencyPercent = offerElement.find(this.option('oldPriceSavedSelector')).data('saved-currency-percent');
                                var price = valCurrencyPercent === 1 ? savedPrice : Math.ceil(savedPrice * 100 / oldPricePP);
                                offerElement.find(this.option('oldPriceSavedSelector')).filter(filterExcludeAlternatives).text(price);
                            } else {
                              offerElement.find('.price--old').hide();
                              offerElement.find('.price--old-saved-wrapper').hide();
                            }
                        }

                        // Sets the offer validity bar state
                        if (newPriceTotal < oldPriceTotal){
                            this._setOfferValidityBarState('cheaper', oldPriceTotal - newPriceTotal);
                        } else if (newPriceTotal > oldPriceTotal) {
                            this._setOfferValidityBarState('expensive', newPriceTotal - oldPriceTotal);
                        } else {
                            this._setOfferValidityBarState('available');
                        }

                        try {
                            if (flightsChanged) {
                                if (!_.isUndefined(resp.flightsChanges.departureFlightTravelDates)) {
                                    offerElement
                                        .find('.offeritem-traveldates.departure:first')
                                        .replaceWith(resp.flightsChanges.departureFlightTravelDates);
                                }

                                if (!_.isUndefined(resp.flightsChanges.returnFlightTravelDates)) {
                                    offerElement
                                        .find('.offeritem-traveldates.return:first')
                                        .replaceWith(resp.flightsChanges.returnFlightTravelDates);
                                }

                                if (!_.isUndefined(resp.flightsChanges.travelPath)) {
                                    offerElement
                                        .find('.offeritem-startstop:first')
                                        .replaceWith(resp.flightsChanges.travelPath);
                                }
                                offerElement.find('[data-fcse-role="flight-changed-status"]:first').show();
                            }
                        } catch (e) {

                        }

                    } else {
                        this._setOfferValidityBarState('available');
                        this.element.addClass('success').text(resp.text/* + ' ' + String.fromCharCode(9654)*/);
                    }

                }
            },
            /**
             * Sets the state of the offer validity bar on top of the offer
             *
             * @param {string} state
             * @private
             */
            _setOfferValidityBarState: function(state, priceDiff)
            {
                var offerElement = this.element.closest(this.option('offer-selector'));
                var offerStates = this.option('offerState');
                var barElement = offerElement.find(this.option('offerValidityBarSelector'));
                var barStates = this.option('offerValidityBarState');

                // Remove states
                offerElement.removeClass([
                    offerStates.checking,
                    offerStates.unavailable,
                    offerStates.cheaper,
                    offerStates.expensive,
                    offerStates.available
                ].join(' '));
                barElement.removeClass([
                    barStates.checking,
                    barStates.unavailable,
                    barStates.cheaper,
                    barStates.expensive,
                    barStates.available
                ].join(' '));

                // Set CSS states
                barElement.addClass(barStates[state]);
                offerElement.addClass(offerStates[state]);

                // Set texts in bar
                barElement.find(this.option('offerValidityBarTextSelector')).each(function(idx, elem){
                    var attr = $(elem).attr('data-statetext-' + state);
                    if (typeof attr !== typeof undefined && attr !== false) {
                        var newText = attr;
                        $(elem).html(newText || '');
                        switch (state)  {
                            case 'cheaper':
                            case 'expensive':
                            case 'available':
                                $(elem).show();
                        }
                    }
                });

                let initTotalPriceElm = offerElement.find('[data-fcse-initial="price-total"]:first');

                switch (state) {
                    case 'cheaper':
                        initTotalPriceElm.hide();
                        break;
                    case 'expensive':
                        initTotalPriceElm.hide();
                        break;
                    case 'available':
                        initTotalPriceElm.show();
                        break;
                }
            },

            /**
             * Redirect to checkout
             *
             * @private
             */
            _redirectToCheckout: function() {
                var url = this._checkRequestResult.checkResult.route;
                var params = {
                        bhubCheck: this._checkRequestResult.checkResult.checkResponse,
                        offerObj: this._checkRequestResult.checkResult.offerObj,
                        ibeparams: this._checkRequestResult.checkResult.ibeparams,
                        mlid: this._checkRequestResult.mlid,
                        coyoteId: this._checkRequestResult.coyoteId,
                        noa: this._checkRequestResult.checkResult.noa,
                        partner: this._checkRequestResult.checkResult.partner
                };
                if (!_.isUndefined(this._checkRequestResult.exchangerate) && this._checkRequestResult.exchangerate !== 1) {
                    params['exchangerate'] = this._checkRequestResult.exchangerate;
                }
                params[this.element.closest('[data-fcse-booking-key]').attr('data-fcse-booking-key')] =
                    this.element.closest('[data-fcse-booking-data]').attr('data-fcse-booking-data');

                var location = new Url();
                if (typeof location.query.kayakclickid !== 'undefined') {
                    params['kayakclickid'] = location.query.kayakclickid;
                }

                var form = $('<form />').attr({'action': url, 'method': 'POST'});
                $.each(params, function( key, value ) {
                    form.append($('<input />').attr({'type': 'hidden', 'name': key, 'value': value}));
                });
                form.submit();
                document.body.appendChild(form[0]);
                form[0].submit();
            }
        });

        return OfferValidityCheckButton;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/offervaliditycheck/offerValidityCheckButton.js